import { AlertTriangle, ArrowRight } from "lucide-react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export function ConceptDecisionPanel({
  selectedStrategy,
  selectedStrategyData,
  isSelectingStrategy = false,
  pendingActionLabel = "Selecting Strategy...",
  actionLabel = "Run Appraisal",
  actionIcon: ActionIcon = ArrowRight,
  onRunAppraisal,
}) {
  return (
    <aside className="space-y-6 lg:sticky lg:top-8">
      <div
        className={cn(
          "rounded-lg border border-border bg-card p-6 text-card-foreground shadow-sm transition-all",
          selectedStrategyData && "border-primary/30 bg-primary/5 ring-1 ring-primary/20",
        )}
      >
        <h3 className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
          Your Decision
        </h3>

        <div className="mt-4 min-h-12">
          {selectedStrategyData ? (
            <div>
              <span className="mb-1 block text-[10px] font-bold uppercase tracking-wider text-primary">
                Selected Strategy
              </span>
              <span className="text-lg font-bold text-foreground">
                {selectedStrategyData.name}
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-2 text-muted-foreground">
              <AlertTriangle className="h-5 w-5" />
              <span className="text-sm font-medium">No strategy selected</span>
            </div>
          )}
        </div>

        <Button
          type="button"
          className="mt-6 w-full font-bold"
          disabled={!selectedStrategyData || isSelectingStrategy}
          onClick={onRunAppraisal}
        >
          {isSelectingStrategy ? pendingActionLabel : actionLabel}
          <ActionIcon aria-hidden="true" />
        </Button>

        <div className="mt-4 text-center">
          <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
            Override Strategy (Advanced)
          </p>
        </div>

        {!selectedStrategyData && selectedStrategy ? (
          <p className="mt-3 text-xs text-muted-foreground">
            Strategy data unavailable. Select another concept.
          </p>
        ) : null}
      </div>
    </aside>
  )
}
